import { render, staticRenderFns } from "./SingleEvents.vue?vue&type=template&id=386aa504"
import script from "./SingleEvents.vue?vue&type=script&lang=js"
export * from "./SingleEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports